import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Autocomplete,
  Divider,
  Toolbar,
  Checkbox,
  
} from '@mui/material';
import { useState, useEffect } from 'react';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import Cancel from '@mui/icons-material/CancelOutlined';
import Header from "../../../Layout/Header";
import { tokens } from "../../../theme/theme";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { useTheme } from '@mui/material/styles';
import PriceListActionMenu from './PriceListActionMenu';

const AddNewPriceList = ({ handlecallback, editPriceListID, editData }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [effectiveStartDate, setEffectiveStartDate] = useState('');
  const [effectiveEndDate, setEffectiveEndDate] = useState('');
  const [fyStartDate, setFyStartDate] = useState('');
  const [status, setStatus] = useState('Active');
  const [basePriceList, setBasePriceList] = useState(null);
  const [basePriceListOptions, setBasePriceListOptions] = useState([]);
  const [valueChangeType, setValueChangeType] = useState('Add');
  const [valueChangeAmount, setValueChangeAmount] = useState('');
  const [applicableStates, setApplicableStates] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [applicableDealers, setApplicableDealers] = useState([]);
  const [selectedDealers, setSelectedDealers] = useState([]);
  const [priceListId, setPriceListId] = useState(editPriceListID || null);

  const statusOptions = ['Active', 'Inactive'];
  const valueChangeOptions = ['Add', 'Deduct'];

  useEffect(() => {
    if (editData) {
      setCode(editData.code || '');
      setName(editData.name || '');
      setEffectiveStartDate(editData.effective_start_date?.substring(0, 10) || '');
      setEffectiveEndDate(editData.effective_end_date?.substring(0, 10) || '');
      setFyStartDate(editData.fystartdate?.substring(0, 10) || '');
      setStatus(editData.priceliststatus || 'Active');
      setBasePriceList(editData.basepricelist?.id ?? null);
      setValueChangeType(editData.valuetype || 'Add');
      setValueChangeAmount(editData.valuechangeamount || '');
      setSelectedStates(editData.applicablestates ?? []);
      setSelectedDealers(editData.applicabledealers ?? []);
    }
  }, [editData]);

  useEffect(() => {
    if (editData?.pricelistid) {
      setPriceListId(editData.pricelistid);
    }
  }, [editData]);

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const param = { p_companyid: 1, p_plantid: 1 };
        const [statesRes, dealersRes, basePLRes] = await Promise.all([
          callApi(API_ENDPOINTS.SALES_PRICELIST_GET_ALL_STATES, 'POST', { 'Content-Type': 'application/json' }, param),
          callApi(API_ENDPOINTS.SALES_PRICELIST_GET_ALL_DEALERS, 'POST', { 'Content-Type': 'application/json' }, param),
          callApi(API_ENDPOINTS.SALES_PRICELIST_GET_ALL_BASE_PRICELIST, 'POST', { 'Content-Type': 'application/json' }, param),
        ]);
        setApplicableStates(statesRes || []);
        setApplicableDealers(dealersRes || []);
        setBasePriceListOptions(basePLRes || []);
      } catch (err) {
        console.error('Dropdown Load Error:', err);
      }
    };
    fetchDropdownData();
  }, []);

  const validateForm = () => {
    if (!code.trim()) return alert("Price List Code is required.");
    if (!name.trim()) return alert("Price List Name is required.");
    if (!effectiveStartDate) return alert("Effective Start Date is required.");
    if (!effectiveEndDate) return alert("Effective End Date is required.");
    if (!fyStartDate) return alert("FY Start Date is required.");
    if (!status) return alert("Status is required.");
    if (!basePriceList) return alert("Base Price List is required.");
    if (!valueChangeAmount || isNaN(valueChangeAmount)) return alert("Valid Value Change Amount is required.");
    if (!valueChangeType) return alert("Value Change Type is required.");
    if (!selectedStates || selectedStates.length === 0) return alert("At least one Applicable State must be selected.");
    if (!selectedDealers || selectedDealers.length === 0) return alert("At least one Applicable Dealer must be selected.");
    return true;
  };
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr; // fallback if invalid
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(/ /g, "-");  // 08-Sep-2025
};
  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      const company_id = localStorage.getItem('companyid') || 13;

      const param = {
        p_companyid: 13,
        p_pricelistid: editPriceListID || 0,
        p_pricelistcode: code,
        p_pricelistname: name,
        p_effective_start_date : formatDate(effectiveStartDate),
        p_effective_end_date: formatDate(effectiveEndDate),
        fystartdate: formatDate(fyStartDate),
        p_priceliststatus: status,
        mode: editPriceListID ? 1 : 0,
        p_basepriceidlist: basePriceList,
        p_valuediffrenceaddordetect: valueChangeType,
        p_valuedifferencefrombasepricelist: valueChangeAmount,
        p_applicablestates: selectedStates.map(s => s.name).join(','),
        p_applicabledealers: selectedDealers.map(d => d.name).join(','),
        plant_id:1,
      };

      const result = await callApi(
        API_ENDPOINTS.SALES_SAVE_PRICELIST,
        'POST',
        { 'Content-Type': 'application/json' },
        param
      );

      console.log("API Response:", result);

      if (Array.isArray(result) && result.length > 0 && result[0]?.priceidlist) {
        const savedId = result[0].priceidlist;
        setPriceListId(savedId);
        alert("Price List Saved Successfully.");
      } else {
        alert("Unexpected API response.");
      }
    } catch (error) {
      console.error("Save error:", error);
      alert(error.message || "Something went wrong while saving.");
    }
  };

  return (
    <Box padding={0}>
      {/* <Header title={editPriceListID ? 'Edit Price List Entry' : 'New Price List Entry'} subtitle="" callback={handlecallback} /> */}
      {/* <Header
  title={editPriceListID ? "Edit Price List Entry" : "New Price List Entry"}
  subtitle=""
  callback={handlecallback}
/> */}
      <Divider />
      <Box sx={{
        padding: "5px",
        borderRadius: "10px",
        maxHeight: '74vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-thumb': { background: colors.blueAccent[600] },
        '&::-webkit-scrollbar-track': { background: colors.primary[400] },
      }}>
        

<PriceListActionMenu
  isEdit={!!editPriceListID}
  onSave={handleSave}
  onDelete={() => console.log("delete")}
  onClear={() => {
    setCode("");
    setName("");
    setEffectiveStartDate("");
    setEffectiveEndDate("");
    setFyStartDate("");
    setStatus("Active");
    setBasePriceList(null);
    setValueChangeAmount("");
    setSelectedStates([]);
    setSelectedDealers([]);
  }}
  onExit={handlecallback}
  saveDisabled={false}
/>

<Divider />

        <Grid container spacing={2} padding="20px">
          <Grid item xs={12} sm={6}><Typography fontSize={14}>Price List Code</Typography><TextField value={code} onChange={e => setCode(e.target.value)} fullWidth size="small" /></Grid>
          <Grid item xs={12} sm={6}><Typography fontSize={14}>Price List Name</Typography><TextField value={name} onChange={e => setName(e.target.value)} fullWidth size="small" /></Grid>
          <Grid item xs={12} sm={6}><Typography fontSize={14}>Effective Start Date</Typography><TextField type="date" value={effectiveStartDate} onChange={e => setEffectiveStartDate(e.target.value)} fullWidth size="small" /></Grid>
          <Grid item xs={12} sm={6}><Typography fontSize={14}>Effective End Date</Typography><TextField type="date" value={effectiveEndDate} onChange={e => setEffectiveEndDate(e.target.value)} fullWidth size="small" /></Grid>
          <Grid item xs={12} sm={6}><Typography fontSize={14}>FY Start Date</Typography><TextField type="date" value={fyStartDate} onChange={e => setFyStartDate(e.target.value)} fullWidth size="small" /></Grid>

          <Grid item xs={12} sm={6}>
            <Typography fontSize={14}>Status</Typography>
            <Autocomplete options={statusOptions} value={status} onChange={(e, v) => v && setStatus(v)} renderInput={params => <TextField {...params} fullWidth size="small" />} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography fontSize={14}>Base Price List</Typography>
            <Autocomplete
              options={basePriceListOptions}
              getOptionLabel={opt => opt.name || ''}
              value={basePriceListOptions.find(opt => opt.code === basePriceList) || null}
              onChange={(e, newVal) => setBasePriceList(newVal ? newVal.code : null)}
              renderInput={params => <TextField {...params} fullWidth size="small" />}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography fontSize={14}>Value Change</Typography>
            <Grid container spacing={1}>
              <Grid item xs={6}><TextField type="number" value={valueChangeAmount} onChange={e => setValueChangeAmount(e.target.value)} fullWidth size="small" /></Grid>
              <Grid item xs={6}><Autocomplete options={valueChangeOptions} value={valueChangeType} onChange={(e, v) => v && setValueChangeType(v)} renderInput={params => <TextField {...params} fullWidth size="small" />} /></Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography fontSize={14}>Applicable States</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={applicableStates}
              getOptionLabel={(option) => option.name}
              value={selectedStates}
              isOptionEqualToValue={(option, value) => option.code === value.code}
              onChange={(event, newValue) => setSelectedStates(newValue)}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Applicable States" size="small" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <Typography fontSize={14}>Applicable Dealers</Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={applicableDealers}
              getOptionLabel={(option) => option.name || ''}
              value={selectedDealers}
              isOptionEqualToValue={(option, value) => option.code === value.code}
              onChange={(event, newValue) => setSelectedDealers(newValue)}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
                  {option.name}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Applicable Dealers" size="small" fullWidth />
              )}
            />
          </Grid>

          <Grid item xs={12} mt={2}>
            <Toolbar disableGutters>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                onClick={handleSave}
                startIcon={<SaveAltIcon />}
                sx={{ textTransform: 'none', mr: 2 }}
              >
                Save
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={{ backgroundColor: 'maroon', textTransform: 'none' }}
                startIcon={<Cancel />}
                onClick={handlecallback}
              >
                Cancel
              </Button>
            </Toolbar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default AddNewPriceList;
